import { render, staticRenderFns } from "./SentAlerts.vue?vue&type=template&id=7ca280f0&scoped=true&"
import script from "./SentAlerts.vue?vue&type=script&lang=js&"
export * from "./SentAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca280f0",
  null
  
)

export default component.exports